<script setup lang="ts">
    import { ref, computed, onMounted } from 'vue'
    import { useKennzahlStore } from '@/js/stores/kennzahl'
    import {
        FileInputField,
        GlobalFormError,
        InfoAlert,
        SuccessAlert
    } from '@/js/components/Common'
    import { getViolationsFeedback, useUploadFile } from '@/js/utils'

    const { file, readFileAsUrl } = useUploadFile()
    const store = useKennzahlStore()

    const isFinished = ref<boolean>(false)

    const kennzahlUploadState = computed<boolean | undefined>(() => {
        if (file.value === null) {
            return
        }

        return Boolean(file.value)
    })

    const isLoading = computed<boolean>(() => {
        return store.isLoading
    })

    const error = computed(() => {
        return store.hasErrors
    })

    const globalErrors = computed(() => {
        return getViolationsFeedback(['fileData'], error.value, true)
    })

    onMounted(() => {
        isFinished.value = false
    })

    const handleKennzahlUpload = async (): Promise<void> => {
        isFinished.value = await store.uploadKennzahlenFile(
            await readFileAsUrl()
        )
    }
</script>

<template>
    <div>
        <v-form class="pa-2" @submit.prevent="handleKennzahlUpload">
            <file-input-field
                v-model="file"
                accept=".csv"
                placeholder="Ziehen Sie die CSV-Datei mit weiteren anzulegenden Kennzahlen hier rein..."
                label="Ziehen Sie die CSV-Datei mit weiteren anzulegenden Kennzahlen hier rein..."
                data-test="input-upload-kennzahl"
                :violation-fields="['fileData']"
                :error="error"
                :is-loading="isLoading"
                :disabled="kennzahlUploadState === null"
            />
            <v-btn
                type="submit"
                block
                color="primary"
                variant="tonal"
                data-test="button-upload-kennzahl"
                :disabled="!kennzahlUploadState || isLoading"
                class="mt-2"
            >
                Kennzahlimport starten
            </v-btn>
            <global-form-error :error="globalErrors" is-html />
            <success-alert :show="isFinished" message="Kennzahlen erfolgreich importiert." />
            <info-alert :show="true">
                <b>Hinweis:</b>
                <ul class="mb-0">
                    <li>
                        Neu hochgeladene Kennzahlen ersetzen bereits existierende Kennzahl-Werte.
                    </li>
                    <li>
                        Um eine Kennzahl fehlend zu setzen, sollte ein leerer String verwendet werden.
                    </li>
                </ul>
            </info-alert>
        </v-form>
    </div>
</template>

<style scoped>

</style>
